<template>
  <div class="addTemplate">
    <div class="container">
      <div class="searchBox">
        <div class="searchBox_top">
          <template v-if="!taskApproval && isSubmit">
            <el-button :key="'save'" type="primary" v-acl="Sensory-templateSave" @click="save">{{$t('visitPlan.draftSave')}}</el-button>
            <el-button :key="'submit'" type="primary" v-acl="Sensory-templateSave" @click="submit">{{$t('common.submit')}}</el-button>
          </template>
          <template v-if="taskApproval">
            <el-button :key="'pass'" type="primary" @click="pass()">{{$t('visitPlan.ApprovalPass')}}</el-button>
            <el-button :key="'reject'" type="primary" @click="refuseVisible = true">{{$t('visitPlan.ApprovalReject')}}</el-button>
          </template>
          <el-button type="primary" @click="historyBack">{{$t('common.close')}}</el-button>
          <!--关闭-->
          <template v-if="!taskApproval && isSubmit" v-acl="Sensory-templateSave">
            <br />
            <label style="font-size:12px;color:#F56C6C;clear: both">{{$t('visitPlan.operationTips')}}</label>
          </template>
        </div>

        <el-form :model="queryCondition" ref="queryCondition" label-width="150px" :rules="queryConditionRules">
          <el-row>
            <el-col span="6">
              <el-form-item :label="$t('sensory.template.SensoryReporttemplateNo')" prop="templateNo">
                <!--Sensory报告模板编号-->
                <el-input v-model="queryCondition.templateNo" placeholder="保存后显示" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item :label="$t('sensory.template.name')" prop="templateName">
                <el-input :disabled="!isSubmit" class="handle-input" v-model="queryCondition.templateName">
                  <el-button slot="append" icon="el-icon-search" class="search_btn" @click.native="showTemplateName(isSubmit)" :disabled="!isSubmit"></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item :label="$t('visitPlan.Remark')" prop="remark">
                <!--备注-->
                <el-popover placement="top-start" :disabled="!showPopover" width="280" trigger="hover" :content="queryCondition.remark">
                  <el-input slot="reference" v-model="queryCondition.remark" :disabled="!isSubmit" clearable maxlength="200"></el-input>
                </el-popover>
              </el-form-item>
            </el-col>
            <el-col span="6">
              <el-form-item :label="$t('sensory.template.createTime')" prop="createDate">
                <!--创建时间   bug：2564 要显示时间，不要只显示日期   bug:2874又不让显示时间，只显示日期-->
                <el-input :value="queryCondition.createDate|dateFormatFilter('YYYY-MM-DD')" disabled clearable></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col span="6">
              <el-form-item :label="$t('sensory.template.createBy')" prop="creator">
                <!--创建人-->
                <el-input v-model="queryCondition.creator" disabled></el-input>
              </el-form-item>
            </el-col>
            <el-col span="12">
              <el-form-item :label="$t('sensory.template.modules')">
                <el-checkbox :disabled="!isSubmit" v-model="queryCondition.showAppearance" label="Appearance"></el-checkbox>
                <el-checkbox :disabled="!isSubmit" v-model="queryCondition.showTexture" label="Texture"></el-checkbox>
                <el-checkbox :disabled="!isSubmit" v-model="queryCondition.showFlavor" label="Flavor"></el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="模板明细" name="first">
          <el-form ref="formTable" :rules="formTableRules" :model="formTable" inline>
            <template v-if="queryCondition.showAppearance">
              <div class="table_title">
                <div class="table_title_sub c1">Appearance</div>
                <el-form-item label="APPEARANCE" prop="appearanceDesc" class="appearanceDesc">
                  <el-input type="textarea" :disabled="!isSubmit" v-model="formTable.appearanceDesc" :rules="formTableRules.appearanceDesc"></el-input>
                </el-form-item>
              </div>
              <div class="toolsBox" v-if="isSubmit">
                <el-button size="small" type="primary" @click="addRowAppearance">{{$t('common.addNewRow')}}</el-button>
                <el-button size="small" type="danger" @click="delRowAppearance">{{$t('common.delRow')}}</el-button>
              </div>
              <el-table :data="formTable.AppearanceList" ref="AppearanceListRef" border :span-method="objectSpanMethod">
                <el-table-column type="selection"></el-table-column>
                <el-table-column label="名称" prop="title" min-width="170">
                  <template slot-scope="scope">
                    <el-form-item :prop="'AppearanceList.' + scope.$index + '.title'" :rules="formTableRules.title">
                      <el-popover placement="bottom" width="160" v-model="scope.row.visible" trigger="manual">
                        <el-input slot="reference" type="textarea" :rows="1" v-model="scope.row.title" @input="handleInput(scope.$index,$event,'APPEARANCE')" ref="textarea"></el-input>
                        <div class="suggestions-box">
                          <div v-for="(suggestion, index) in ['Comments']" :key="index" @click="selectSuggestion(suggestion,scope.$index,'APPEARANCE')" style="cursor:pointer">
                            {{ suggestion }}
                          </div>
                        </div>
                      </el-popover>
                      <!-- <el-autocomplete v-if="scope.row.isComments=='Y'" class="inline-input" v-model="scope.row.title" :fetch-suggestions="querySearch" @input="handleInput(scope.$index,$event,'APPEARANCE')" placeholder="请输入内容" :disabled="!isSubmit" style="width:100%"></el-autocomplete> -->
                      <!-- <el-input v-else type="textarea" :rows="2" placeholder="请输入内容" v-model="scope.row.title" @input="handleInput(scope.$index,$event,'APPEARANCE')" style="width:100%" :disabled="!isSubmit"></el-input> -->
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="1" prop="detail1">
                  <template slot-scope="scope">
                    <el-form-item :prop="'AppearanceList.' + scope.$index + '.detail1'">
                      <el-tooltip class="item" :content=scope.row.detail1 placement="top" v-if="!isSubmit &&scope.row.detail1">
                        <el-input v-model="scope.row.detail1" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail1" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="2" prop="detail2">
                  <template slot-scope="scope">
                    <el-form-item :prop="'AppearanceList.' + scope.$index + '.detail2'">
                      <el-tooltip class="item" :content=scope.row.detail2 placement="top" v-if="!isSubmit &&scope.row.detail2">
                        <el-input v-model="scope.row.detail2" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail2" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="3" prop="detail3">
                  <template slot-scope="scope">
                    <el-form-item :prop="'AppearanceList.' + scope.$index + '.detail3'">
                      <el-tooltip class="item" :content=scope.row.detail3 placement="top" v-if="!isSubmit &&scope.row.detail3">
                        <el-input v-model="scope.row.detail3" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail3" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="4" prop="detail4">
                  <template slot-scope="scope">
                    <el-form-item :prop="'AppearanceList.' + scope.$index + '.detail4'">
                      <el-tooltip class="item" :content=scope.row.detail4 placement="top" v-if="!isSubmit &&scope.row.detail4">
                        <el-input v-model="scope.row.detail4" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail4" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="5" prop="detail5">
                  <template slot-scope="scope">
                    <el-form-item :prop="'AppearanceList.' + scope.$index + '.detail5'">
                      <el-tooltip class="item" :content=scope.row.detail5 placement="top" v-if="!isSubmit &&scope.row.detail5">
                        <el-input v-model="scope.row.detail5" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail5" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="6" prop="detail6">
                  <template slot-scope="scope">
                    <el-form-item :prop="'AppearanceList.' + scope.$index + '.detail6'">
                      <el-tooltip class="item" :content=scope.row.detail6 placement="top" v-if="!isSubmit &&scope.row.detail6">
                        <el-input v-model="scope.row.detail6" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail6" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="7" prop="detail7">
                  <template slot-scope="scope">
                    <el-form-item :prop="'AppearanceList.' + scope.$index + '.detail7'">
                      <el-tooltip class="item" :content=scope.row.detail7 placement="top" v-if="!isSubmit &&scope.row.detail7">
                        <el-input v-model="scope.row.detail7" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail7" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="8" prop="detail8">
                  <template slot-scope="scope">
                    <el-form-item :prop="'AppearanceList.' + scope.$index + '.detail8'">
                      <el-tooltip class="item" :content=scope.row.detail8 placement="top" v-if="!isSubmit &&scope.row.detail8">
                        <el-input v-model="scope.row.detail8" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail8" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="9" prop="detail9">
                  <template slot-scope="scope">
                    <el-form-item :prop="'AppearanceList.' + scope.$index + '.detail9'">
                      <el-tooltip class="item" :content=scope.row.detail9 placement="top" v-if="!isSubmit &&scope.row.detail9">
                        <el-input v-model="scope.row.detail9" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail9" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column :key="index" v-for="(item,index) in demolist" >
                                         <el-input v-model="demolist[index]" @input="change($event,index)"></el-input>
                                        <el-form-item >
                                                <el-input v-model="demolist[index]" @input="change($event,index)"></el-input>
                                        </el-form-item>
                                </el-table-column>-->
              </el-table>
            </template>
            <template v-if="queryCondition.showTexture">
              <div class="table_title">
                <div class="table_title_sub c1">Texture</div>
                <el-form-item label="TEXTURE/ MOUTHFEEL" prop="textureDesc" class="appearanceDesc">
                  <el-input type="textarea" :disabled="!isSubmit" v-model="formTable.textureDesc" :rules="formTableRules.textureDesc"></el-input>
                </el-form-item>
              </div>
              <div class="toolsBox" v-if="isSubmit">
                <el-button size="small" type="primary" @click="addRowTexture">{{$t('common.addNewRow')}}</el-button>
                <el-button size="small" type="danger" @click="delRowTexture">{{$t('common.delRow')}}</el-button>
              </div>
              <el-table :data="formTable.TextureList" ref="TextureListRef" border :span-method="objectSpanMethod">
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip label="名称" prop="title" min-width="170">
                  <template slot-scope="scope">
                    <el-form-item :prop="'TextureList.' + scope.$index + '.title'" :rules="formTableRules.title">
                      <el-popover placement="bottom" width="160" v-model="scope.row.visible" trigger="manual">
                        <el-input slot="reference" type="textarea" :rows="1" v-model="scope.row.title" @input="handleInput(scope.$index,$event,'TEXTURE')" ref="textarea"></el-input>
                        <div class="suggestions-box">
                          <div v-for="(suggestion, index) in ['Comments']" :key="index" @click="selectSuggestion(suggestion,scope.$index,'TEXTURE')" style="cursor:pointer">
                            {{ suggestion }}
                          </div>
                        </div>
                      </el-popover>
                      <!-- <el-autocomplete v-if="scope.row.isComments=='Y'" class="inline-input" v-model="scope.row.title" :fetch-suggestions="querySearch" @input="handleInput(scope.$index,$event,'TEXTURE')" :disabled="!isSubmit" placeholder="请输入内容" style="width:100%"></el-autocomplete> -->
                      <!-- <el-input v-else type="textarea" :rows="2" placeholder="请输入内容" v-model="scope.row.title" @input="handleInput(scope.$index,$event,'TEXTURE')" style="width:100%" :disabled="!isSubmit"></el-input> -->
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="1" prop="detail1">
                  <template slot-scope="scope">
                    <el-form-item :prop="'TextureList.' + scope.$index + '.detail1'">
                      <el-tooltip class="item" :content=scope.row.detail1 placement="top" v-if="!isSubmit &&scope.row.detail1">
                        <el-input v-model="scope.row.detail1" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail1" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="2" prop="detail2">
                  <template slot-scope="scope">
                    <el-form-item :prop="'TextureList.' + scope.$index + '.detail2'">
                      <el-tooltip class="item" :content=scope.row.detail2 placement="top" v-if="!isSubmit &&scope.row.detail2">
                        <el-input v-model="scope.row.detail2" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail2" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="3" prop="detail3">
                  <template slot-scope="scope">
                    <el-form-item :prop="'TextureList.' + scope.$index + '.detail3'">
                      <el-tooltip class="item" :content=scope.row.detail3 placement="top" v-if="!isSubmit &&scope.row.detail3">
                        <el-input v-model="scope.row.detail3" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail3" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="4" prop="detail4">
                  <template slot-scope="scope">
                    <el-form-item :prop="'TextureList.' + scope.$index + '.detail4'">
                      <el-tooltip class="item" :content=scope.row.detail4 placement="top" v-if="!isSubmit &&scope.row.detail4">
                        <el-input v-model="scope.row.detail4" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail4" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="5" prop="detail5">
                  <template slot-scope="scope">
                    <el-form-item :prop="'TextureList.' + scope.$index + '.detail5'">
                      <el-tooltip class="item" :content=scope.row.detail5 placement="top" v-if="!isSubmit &&scope.row.detail5">
                        <el-input v-model="scope.row.detail5" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail5" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="6" prop="detail6">
                  <template slot-scope="scope">
                    <el-form-item :prop="'TextureList.' + scope.$index + '.detail6'">
                      <el-tooltip class="item" :content=scope.row.detail6 placement="top" v-if="!isSubmit &&scope.row.detail6">
                        <el-input v-model="scope.row.detail6" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail6" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="7" prop="detail7">
                  <template slot-scope="scope">
                    <el-form-item :prop="'TextureList.' + scope.$index + '.detail7'">
                      <el-tooltip class="item" :content=scope.row.detail7 placement="top" v-if="!isSubmit &&scope.row.detail7">
                        <el-input v-model="scope.row.detail7" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail7" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="8" prop="detail8">
                  <template slot-scope="scope">
                    <el-form-item :prop="'TextureList.' + scope.$index + '.detail8'">
                      <el-tooltip class="item" :content=scope.row.detail8 placement="top" v-if="!isSubmit &&scope.row.detail8">
                        <el-input v-model="scope.row.detail8" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail8" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="9" prop="detail9">
                  <template slot-scope="scope">
                    <el-form-item :prop="'TextureList.' + scope.$index + '.detail9'">
                      <el-tooltip class="item" :content=scope.row.detail9 placement="top" v-if="!isSubmit &&scope.row.detail9">
                        <el-input v-model="scope.row.detail9" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail9" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
            </template>
            <template v-if="queryCondition.showFlavor">
              <div class="table_title">
                <div class="table_title_sub c1">Flavor</div>
                <el-form-item label="AROMA/ FLAVOR" prop="flavorDesc" class="appearanceDesc">
                  <el-input type="textarea" :disabled="!isSubmit" v-model="formTable.flavorDesc" :rules="formTableRules.flavorDesc"></el-input>
                </el-form-item>
              </div>
              <div class="toolsBox" v-if="isSubmit">
                <el-button size="small" type="primary" @click="addRowFlavor">{{$t('common.addNewRow')}}</el-button>
                <el-button size="small" type="danger" @click="delRowFlavor">{{$t('common.delRow')}}</el-button>
              </div>
              <el-table :data="formTable.FlavorList" ref="FlavorListRef" border :span-method="objectSpanMethod">
                <el-table-column type="selection"></el-table-column>
                <el-table-column show-overflow-tooltip label="名称" prop="title" min-width="170">
                  <template slot-scope="scope">
                    <el-form-item :prop="'FlavorList.' + scope.$index + '.title'" :rules="formTableRules.title">
                      <el-popover placement="bottom" width="160" v-model="scope.row.visible" trigger="manual">
                        <el-input slot="reference" type="textarea" :rows="1" v-model="scope.row.title" @input="handleInput(scope.$index,$event,'FLAVOR')" ref="textarea"></el-input>
                        <div class="suggestions-box">
                          <div v-for="(suggestion, index) in ['Comments']" :key="index" @click="selectSuggestion(suggestion,scope.$index,'FLAVOR')" style="cursor:pointer">
                            {{ suggestion }}
                          </div>
                        </div>
                      </el-popover>
                      <!-- <el-autocomplete v-if="scope.row.isComments=='Y'" class="inline-input" v-model="scope.row.title" :fetch-suggestions="querySearch" @input="handleInput(scope.$index,$event,'FLAVOR')" placeholder="请输入内容" :disabled="!isSubmit" style="width:100%"></el-autocomplete> -->
                      <!-- <el-input v-else type="textarea" :rows="2" placeholder="请输入内容" v-model="scope.row.title" @input="handleInput(scope.$index,$event,'FLAVOR')" style="width:100%" :disabled="!isSubmit"></el-input> -->
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="1" prop="detail1">
                  <template slot-scope="scope">
                    <el-form-item :prop="'FlavorList.' + scope.$index + '.detail1'">
                      <el-tooltip class="item" :content=scope.row.detail1 placement="top" v-if="!isSubmit &&scope.row.detail1">
                        <el-input v-model="scope.row.detail1" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail1" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="2" prop="detail2">
                  <template slot-scope="scope">
                    <el-form-item :prop="'FlavorList.' + scope.$index + '.detail2'">
                      <el-tooltip class="item" :content=scope.row.detail2 placement="top" v-if="!isSubmit &&scope.row.detail2">
                        <el-input v-model="scope.row.detail2" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail2" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="3" prop="detail3">
                  <template slot-scope="scope">
                    <el-form-item :prop="'FlavorList.' + scope.$index + '.detail3'">
                      <el-tooltip class="item" :content=scope.row.detail3 placement="top" v-if="!isSubmit &&scope.row.detail3">
                        <el-input v-model="scope.row.detail3" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail3" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="4" prop="detail4">
                  <template slot-scope="scope">
                    <el-form-item :prop="'FlavorList.' + scope.$index + '.detail4'">
                      <el-tooltip class="item" :content="scope.row.detail4" placement="top" v-if="!isSubmit &&scope.row.detail4">
                        <el-input v-model="scope.row.detail4" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail4" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="5" prop="detail5">
                  <template slot-scope="scope">
                    <el-form-item :prop="'FlavorList.' + scope.$index + '.detail5'">
                      <el-tooltip class="item" :content=scope.row.detail5 placement="top" v-if="!isSubmit &&scope.row.detail5">
                        <el-input v-model="scope.row.detail5" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail5" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="6" prop="detail6">
                  <template slot-scope="scope">
                    <el-form-item :prop="'FlavorList.' + scope.$index + '.detail6'">
                      <el-tooltip class="item" :content=scope.row.detail6 placement="top" v-if="!isSubmit &&scope.row.detail6">
                        <el-input v-model="scope.row.detail6" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail6" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="7" prop="detail7">
                  <template slot-scope="scope">
                    <el-form-item :prop="'FlavorList.' + scope.$index + '.detail7'">
                      <el-tooltip class="item" :content=scope.row.detail7 placement="top" v-if="!isSubmit &&scope.row.detail7">
                        <el-input v-model="scope.row.detail7" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail7" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="8" prop="detail8">
                  <template slot-scope="scope">
                    <el-form-item :prop="'FlavorList.' + scope.$index + '.detail8'">
                      <el-tooltip class="item" :content="scope.row.detail8" placement="top" v-if="!isSubmit &&scope.row.detail8">
                        <el-input v-model="scope.row.detail8" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail8" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip label="9" prop="detail9">
                  <template slot-scope="scope">
                    <el-form-item :prop="'FlavorList.' + scope.$index + '.detail9'">
                      <el-tooltip class="item" :content=scope.row.detail9 placement="top" v-if="!isSubmit &&scope.row.detail9">
                        <el-input v-model="scope.row.detail9" :disabled="!isSubmit">&nbsp;</el-input>
                      </el-tooltip>
                      <el-input v-model="scope.row.detail9" :disabled="!isSubmit" v-else>&nbsp;</el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="模板产品明细" name="second">
          <el-table :data="materialsList" border fit>
            <el-table-column show-overflow-tooltip prop="fiveBitCode" :label="$t('sensory.template.productNumber') "></el-table-column>
            <el-table-column show-overflow-tooltip prop="fiveBitCodeName" :label="$t('sensory.template.productName') "></el-table-column>
            <el-table-column show-overflow-tooltip prop="version" :label="$t('sensory.template.productTemplateVersionNumber') ">
              <template slot-scope="scope">
                {{scope.row.version==null?'':('V'+scope.row.version)}}
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="isActive" :formatter="formatActive" :label="$t('sensory.template.isEffective') "></el-table-column>
          </el-table>
        </el-tab-pane>
        <!-- <el-tab-pane  :label="$t('common.approvalLog')" name="third" v-if="taskApproval"> -->
        <el-tab-pane :label="$t('common.approvalLog')" name="third" v-if="ttSensoryTemplateId">
          <el-table :data="logList" border fit>
            <el-table-column show-overflow-tooltip prop="createDate" :label="$t('common.OperationTime') ">
              <template slot-scope="scope">{{scope.row.createDate | dateFormatFilter("YYYY-MM-DD HH:mm:ss")}}</template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="operatorName" :label="$t('common.OperatorName') "></el-table-column>
            <el-table-column show-overflow-tooltip prop="action" :label="$t('common.PedagogicalOperation') "></el-table-column>
            <el-table-column show-overflow-tooltip prop="comments" :label="$t('common.remarks') "></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <el-dialog title="审批拒绝" :visible.sync="refuseVisible">
        <el-form :model="refuseForm" ref="refuseForm" :rules="refuseFormRules" inline>
          <el-form-item label="请填写拒绝原因 " label-width="120" prop="comments">
            <el-input v-model="refuseForm.comments" maxlength="300"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="refuseVisible = false" type="primary">取 消</el-button>
          <el-button type="primary" @click="refuse('refuseForm')">确 定</el-button>
        </div>
      </el-dialog>
      <el-dialog :visible.sync="showTemplateNameDialog" width="80%" title="产品选择器">
        <PickupFiveBitCode @pickup="selectTemplateName" :multi='true'></PickupFiveBitCode>
      </el-dialog>
      <el-dialog :visible.sync="showUserDialog" width="80%" title="模板审批人选择器">
        <PickupUser @input="selectUserData"></PickupUser>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import PickupFiveBitCode from "@/components/page/sensory/sensory-template/templateName";
import {
  saveTemplate,
  getTemplateDetails,
  approvalPass
} from "@/api/sensory/template";
import PickupUser from "@/components/page/sensory/sensory-template/choiceUser";

export default {
  components: { PickupFiveBitCode, PickupUser },
  data() {
    var templateNameValid = (rule, value, callback) => {
      console.log('this.queryCondition.templateName', this.queryCondition.templateName);
      console.log('that.materialsList', this.materialsList);
      if (!this.queryCondition.templateName || this.materialsList.length === 0) {
        callback(new Error("请先选择产品后再修改模板名称！"));
      } else {
        callback();
      }
    };
    return {
      isSubmit: true,
      showDialog: false,
      taskApproval: false,
      refuseVisible: false,
      auditorId: "", //选择的审批人
      ttSensoryTemplateId: "",
      showUserDialog: false,
      activeName: "first",
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        createDate: "",
        creator: "",
        fiveBitCode: "",
        fiveBitCodeName: "",
        templateName: '',
        showAppearance: true,
        showTexture: true,
        showFlavor: true
      },

      formTable: {
        AppearanceList: [],
        TextureList: [],
        FlavorList: []
      },
      refuseForm: {
        comments: ""
      },
      showTemplateNameDialog: false,
      materialsList: [],
      logList: [],
      showPopover: false,
      formTableRules: {
        title: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: ["blur", "change"] }
        ],
        appearanceDesc: [
          { required: true, message: this.$t("visitPlan.noEmpty"), trigger: "blur" }
        ],
        textureDesc: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: "blur" }],
        flavorDesc: [{ required: true, message: this.$t("visitPlan.noEmpty"), trigger: "blur" }]
      },
      queryConditionRules: {
        remark: [
          { min: 0, max: 201, message: '备注超出长度', trigger: 'blur' }
        ],
        templateName: [
          { required: true, trigger: "change", validator: templateNameValid }
        ]
      },
      refuseFormRules: {
        comments: [
          {
            required: true,
            message: this.$t("visitPlan.noEmpty"),
            trigger: "blur"
          }
        ]
      },
      // 定义需要触发的关键词序列
      triggerKeywords: [
        'C', 'Co', 'Com', 'Comm', 'Comme',
        'Commen', 'Comment', 'Comments'
      ],
    };
  },
  watch: {
    auditorId: function (newVal, oldVal) {
      //选完审批人后直接提交
      if (newVal) {
        this.submit()
      }

    }
  },
  computed: {},
  created() {
    var date = new Date();
    this.queryCondition.creator = localStorage.getItem("ms_username");
    this.queryCondition.createDate = this.$options.filters["dateFormatFilter"](date);
    if (this.$route.query.ttSensoryTemplateId) {
      this.ttSensoryTemplateId = this.$route.query.ttSensoryTemplateId;
      this.getDetail(this.$route.query.ttSensoryTemplateId);
    }
  },
  methods: {
    getDetail(ttSensoryTemplateId) {
      let that = this;
      getTemplateDetails(ttSensoryTemplateId).then(res => {
        console.log("🚀 ~ file: addTemplate.vue ~ line 570 ~ getTemplateDetails ~ res", res)
        if (this.$route.query.taskApproval) {
          //从任务列表进来审批,如果拒绝了 可以再次编辑
          if (!res.data.canAudit) {
            this.taskApproval = false;
            this.isSubmit = true;
          } else {
            this.taskApproval = true;
            this.isSubmit = false;
          }
        }
        this.$set(that.queryCondition, "templateNo", res.data.templateNo);
        this.$set(
          that.queryCondition,
          "templateName",
          res.data.templateName
        );
        this.$set(that.queryCondition, "remark", res.data.remark);
        if (!!that.queryCondition.remark) {
          that.showPopover = true;
        }
        this.$set(that.queryCondition, "createDate", res.data.createDate);
        this.$set(that.queryCondition, "creator", res.data.creator);
        that.queryCondition.showAppearance = (res.data.needAppearance == 'Y');
        that.queryCondition.showTexture = (res.data.needTexture == 'Y');
        that.queryCondition.showFlavor = (res.data.needFlavor == 'Y');
        this.materialsList = res.data.materials;
        this.$set(that.formTable, "appearanceDesc", res.data.appearanceDesc);
        this.$set(that.formTable, "textureDesc", res.data.textureDesc);
        this.$set(that.formTable, "flavorDesc", res.data.flavorDesc);
        let templateDetails = res.data.templateDetails;
        for (let i = 0, len = templateDetails.length; i < len; i++) {
          if (templateDetails[i].title == "Comments") {
            templateDetails[i].detail1 = templateDetails[i].detail;
          } else {
            let detail = templateDetails[i].detail.split("`");
            for (let j = 0, len2 = detail.length; j < len2; j++) {
              templateDetails[i].detail1 = detail[0];
              templateDetails[i].detail2 = detail[1];
              templateDetails[i].detail3 = detail[2];
              templateDetails[i].detail4 = detail[3];
              templateDetails[i].detail5 = detail[4];
              templateDetails[i].detail6 = detail[5];
              templateDetails[i].detail7 = detail[6];
              templateDetails[i].detail8 = detail[7];
              templateDetails[i].detail9 = detail[8];
            }
          }
          if (templateDetails[i].detailType == "APPEARANCE") {
            that.formTable.AppearanceList.push(templateDetails[i]);
          }
          if (templateDetails[i].detailType == "TEXTURE") {
            that.formTable.TextureList.push(templateDetails[i]);
          }
          if (templateDetails[i].detailType == "FLAVOR") {
            that.formTable.FlavorList.push(templateDetails[i]);
          }
          that.logList = res.data.logs;
        }
        //循环数组添加删除用的标示
        for (let i = 0, len = that.formTable.AppearanceList.length; i < len; i++) {
          that.formTable.AppearanceList[i].delIds = i;
          that.formTable.AppearanceList[i].visible = false;
        }
        for (let i = 0, len = that.formTable.TextureList.length; i < len; i++) {
          that.formTable.TextureList[i].delIds = i;
          that.formTable.TextureList[i].visible = false;
        }
        for (let i = 0, len = that.formTable.FlavorList.length; i < len; i++) {
          that.formTable.FlavorList[i].delIds = i;
          that.formTable.FlavorList[i].visible = false;
        }
        let status = res.data.materials[0].status;
        if (status == "SUBMIT") {
          //提交之后不能修改
          that.isSubmit = false;
        } else if (status == "PASS") {
          that.isSubmit = false;
        } else if (status == 'DISABLE') {
          that.isSubmit = false;
        }
      });
    },
    save() {
      this.$refs['queryCondition'].validate((valid) => {
        if (valid) {
          let that = this;
          let tempList = [];
          let AppearanceList = that.formTable.AppearanceList;
          if (AppearanceList.length > 0) {
            for (let i = 0, len = AppearanceList.length; i < len; i++) {
              if (AppearanceList[i].title == "Comments") {
                AppearanceList[i].isComments = "Y";
                AppearanceList[i].detail = AppearanceList[i].detail1;
              } else {
                AppearanceList[i].isComments = "N";
                let detailArr = [];
                detailArr.push(AppearanceList[i].detail1);
                detailArr.push(AppearanceList[i].detail2);
                detailArr.push(AppearanceList[i].detail3);
                detailArr.push(AppearanceList[i].detail4);
                detailArr.push(AppearanceList[i].detail5);
                detailArr.push(AppearanceList[i].detail6);
                detailArr.push(AppearanceList[i].detail7);
                detailArr.push(AppearanceList[i].detail8);
                detailArr.push(AppearanceList[i].detail9);
                AppearanceList[i].detail = detailArr.join("`");
              }
              tempList.push(AppearanceList[i]);
            }
          }
          let TextureList = that.formTable.TextureList;
          if (TextureList.length > 0) {
            for (let i = 0, len = TextureList.length; i < len; i++) {
              if (TextureList[i].title == "Comments") {
                TextureList[i].isComments = "Y";
                TextureList[i].detail = TextureList[i].detail1;
              } else {
                TextureList[i].isComments = "N";
                let detailArr = [];
                detailArr.push(TextureList[i].detail1);
                detailArr.push(TextureList[i].detail2);
                detailArr.push(TextureList[i].detail3);
                detailArr.push(TextureList[i].detail4);
                detailArr.push(TextureList[i].detail5);
                detailArr.push(TextureList[i].detail6);
                detailArr.push(TextureList[i].detail7);
                detailArr.push(TextureList[i].detail8);
                detailArr.push(TextureList[i].detail9);
                TextureList[i].detail = detailArr.join("`");
              }
              tempList.push(TextureList[i]);
            }
          }
          let FlavorList = that.formTable.FlavorList;
          if (FlavorList.length > 0) {
            for (let i = 0, len = FlavorList.length; i < len; i++) {
              if (FlavorList[i].title == "Comments") {
                FlavorList[i].isComments = "Y";
                FlavorList[i].detail = FlavorList[i].detail1;
              } else {
                FlavorList[i].isComments = "N";
                let detailArr = [];
                detailArr.push(FlavorList[i].detail1);
                detailArr.push(FlavorList[i].detail2);
                detailArr.push(FlavorList[i].detail3);
                detailArr.push(FlavorList[i].detail4);
                detailArr.push(FlavorList[i].detail5);
                detailArr.push(FlavorList[i].detail6);
                detailArr.push(FlavorList[i].detail7);
                detailArr.push(FlavorList[i].detail8);
                detailArr.push(FlavorList[i].detail9);
                FlavorList[i].detail = detailArr.join("`");
              }
              tempList.push(FlavorList[i]);
            }
          }
          var templateDetails = tempList.map(function (item) {
            let obj = {
              title: item["title"],
              isComments: item["isComments"],
              detail: item["detail"],
              detailType: item["detailType"],
              ttTemplateDetailId: item["ttTemplateDetailId"]
                ? item["ttTemplateDetailId"]
                : "",
              ttSensoryTemplateId: that.ttSensoryTemplateId
                ? that.ttSensoryTemplateId
                : ""
            };
            return obj;
          });
          let materials = [
            {
              fiveBitCode: this.queryCondition.fiveBitCode,
              fiveBitCodeName: this.queryCondition.fiveBitCodeName
            }
          ];
          let data = {
            ttSensoryTemplateId: that.ttSensoryTemplateId
              ? that.ttSensoryTemplateId
              : "",
            materials:
              this.materialsList.length == 0 ? materials : this.materialsList,
            templateNo: that.queryCondition.templateNo
              ? that.queryCondition.templateNo
              : "",
            templateName: that.queryCondition.templateName,
            createDate: "",
            creator: "",
            remark: that.queryCondition.remark ? that.queryCondition.remark : "",
            appearanceDesc: that.formTable.appearanceDesc,
            textureDesc: that.formTable.textureDesc,
            flavorDesc: that.formTable.flavorDesc,
            needAppearance: that.queryCondition.showAppearance ? 'Y' : 'N',
            needTexture: that.queryCondition.showTexture ? 'Y' : 'N',
            needFlavor: that.queryCondition.showFlavor ? 'Y' : 'N',
            templateDetails: templateDetails,
            status: "DRAFT"
          };
          console.log(data);
          saveTemplate(data).then(res => {
            if (res.code == 200) {
              that.$message({
                message: this.$t("common.saveSuccess"),
                type: "success"
              });
              that.formTable.AppearanceList = [];
              that.formTable.TextureList = [];
              that.formTable.FlavorList = [];
              that.ttSensoryTemplateId = res.data.ttSensoryTemplateId;
              that.getDetail(res.data.ttSensoryTemplateId);
              that.$set(that.queryCondition, "templateNo", res.data.templateNo);
            }
          });
        }
      })
    },
    submit() {
      let that = this;
      const p1 = new Promise((resolve, reject) => {
        this.$refs["queryCondition"].validate(valid => {
          if (valid) resolve()
        })
      })

      const p2 = new Promise((resolve, reject) => {
        this.$refs["formTable"].validate(valid => {
          if (valid) resolve()
        })
      })

      Promise.all([p1, p2]).then(() => {
        let tempList = [];
        let AppearanceList = that.formTable.AppearanceList;
        if (AppearanceList.length < 1 && that.queryCondition.showAppearance) {
          that.$message({
            message: this.$t("sensory.template.PleaseMaintainDetailLine"),
            type: "error"
          });
          return;
        }
        for (let i = 0, len = AppearanceList.length; i < len; i++) {
          if (AppearanceList[i].title == "Comments") {
            AppearanceList[i].isComments = "Y";
            AppearanceList[i].detail = AppearanceList[i].detail1;
          } else {
            AppearanceList[i].isComments = "N";
            let detailArr = [];
            detailArr.push(AppearanceList[i].detail1);
            detailArr.push(AppearanceList[i].detail2);
            detailArr.push(AppearanceList[i].detail3);
            detailArr.push(AppearanceList[i].detail4);
            detailArr.push(AppearanceList[i].detail5);
            detailArr.push(AppearanceList[i].detail6);
            detailArr.push(AppearanceList[i].detail7);
            detailArr.push(AppearanceList[i].detail8);
            detailArr.push(AppearanceList[i].detail9);
            AppearanceList[i].detail = detailArr.join("`");
          }
          tempList.push(AppearanceList[i]);
        }
        let TextureList = that.formTable.TextureList;
        if (TextureList.length < 1 && that.queryCondition.showTexture) {
          that.$message({
            message: this.$t("sensory.template.PleaseMaintainDetailLine"),
            type: "error"
          });
          return;
        }
        for (let i = 0, len = TextureList.length; i < len; i++) {
          if (TextureList[i].title == "Comments") {
            TextureList[i].isComments = "Y";
            TextureList[i].detail = TextureList[i].detail1;
          } else {
            TextureList[i].isComments = "N";
            let detailArr = [];
            detailArr.push(TextureList[i].detail1);
            detailArr.push(TextureList[i].detail2);
            detailArr.push(TextureList[i].detail3);
            detailArr.push(TextureList[i].detail4);
            detailArr.push(TextureList[i].detail5);
            detailArr.push(TextureList[i].detail6);
            detailArr.push(TextureList[i].detail7);
            detailArr.push(TextureList[i].detail8);
            detailArr.push(TextureList[i].detail9);
            TextureList[i].detail = detailArr.join("`");
          }
          tempList.push(TextureList[i]);
        }
        let FlavorList = that.formTable.FlavorList;
        if (FlavorList.length < 1 && that.queryCondition.showFlavor) {
          that.$message({
            message: this.$t("sensory.template.PleaseMaintainDetailLine"),
            type: "error"
          });
          return;
        }
        for (let i = 0, len = FlavorList.length; i < len; i++) {
          if (FlavorList[i].title == "Comments") {
            FlavorList[i].isComments = "Y";
            FlavorList[i].detail = FlavorList[i].detail1;
          } else {
            FlavorList[i].isComments = "N";
            let detailArr = [];
            detailArr.push(FlavorList[i].detail1);
            detailArr.push(FlavorList[i].detail2);
            detailArr.push(FlavorList[i].detail3);
            detailArr.push(FlavorList[i].detail4);
            detailArr.push(FlavorList[i].detail5);
            detailArr.push(FlavorList[i].detail6);
            detailArr.push(FlavorList[i].detail7);
            detailArr.push(FlavorList[i].detail8);
            detailArr.push(FlavorList[i].detail9);
            FlavorList[i].detail = detailArr.join("`");
          }
          tempList.push(FlavorList[i]);
        }
        var templateDetails = tempList.map(function (item) {
          let obj = {
            title: item["title"],
            isComments: item["isComments"],
            detail: item["detail"],
            detailType: item["detailType"],
            ttTemplateDetailId: item["ttTemplateDetailId"]
              ? item["ttTemplateDetailId"]
              : "",
            ttSensoryTemplateId: that.ttSensoryTemplateId
              ? that.ttSensoryTemplateId
              : ""
          };
          return obj;
        });
        let materials = [
          {
            fiveBitCode: this.queryCondition.fiveBitCode,
            fiveBitCodeName: this.queryCondition.fiveBitCodeName
          }
        ];
        //判断有没有审批人
        if (that.auditorId == '' || that.auditorId == undefined) {
          this.showUserDialog = true
          return false;
        }
        let data = {
          ttSensoryTemplateId: that.ttSensoryTemplateId
            ? that.ttSensoryTemplateId
            : "",
          materials:
            this.materialsList.length == 0 ? materials : this.materialsList,
          templateNo: that.queryCondition.templateNo
            ? that.queryCondition.templateNo
            : "",
          templateName: that.queryCondition.templateName,
          createDate: "",
          creator: "",
          remark: that.queryCondition.remark ? that.queryCondition.remark : "",
          appearanceDesc: that.formTable.appearanceDesc,
          textureDesc: that.formTable.textureDesc,
          flavorDesc: that.formTable.flavorDesc,
          needAppearance: that.queryCondition.showAppearance ? 'Y' : 'N',
          needTexture: that.queryCondition.showTexture ? 'Y' : 'N',
          needFlavor: that.queryCondition.showFlavor ? 'Y' : 'N',
          templateDetails: templateDetails,
          auditorId: that.auditorId,
          status: "SUBMIT"
        };
        console.log(data);
        saveTemplate(data).then(res => {
          if (res.code == 200) {
            that.$message({
              message: this.$t("common.submitSuccess"),
              type: "success"
            });
            that.taskApproval = false;
            that.isSubmit = false;

            if (window.opener.location.pathname == window.location.pathname) {
              window.close();
            } else {
              that.$router.go(-1);
            }
          }
        });
      })

    },
    getTemplateName() {
      this.showTemplateNameDialog = true;
    },
    selectTemplateName(list) {
      console.log("🚀 ~ file: addTemplate.vue ~ line 949 ~ selectTemplateName ~ list", list)
      let that = this
      if (list.length > 0) {
        that.queryCondition.templateName = list.map(data => data.fiveBitCodeName).join(',');
        var materialsList = list.map(function (item) {
          let obj = {
            fiveBitCode: item["fiveBitCode"],
            fiveBitCodeName: item["fiveBitCodeName"],
          };
          return obj;
        });
        console.log("🚀 ~ file: addTemplate.vue ~ line 966 ~ materialsList ~ materialsList", materialsList)
        that.materialsList = materialsList
      }

      this.showTemplateNameDialog = false;
    },
    selectUserData(name, id) {
      this.auditorId = id
      this.showUserDialog = false
    },
    pass() {
      let that = this;
      let data = {
        action: "audit",
        // templateId:that.ttSensoryTemplateId,
        status: "PASS"
      };
      approvalPass(that.ttSensoryTemplateId, data).then(res => {
        if (res.code == 200) {
          that.$message({
            message: "审批通过",
            type: "success"
          });
          that.$router.go(-1);
        }
      });
    },
    refuse(refuseForm) {
      let that = this;
      this.$refs.refuseForm.validate(valid => {
        if (valid) {
          that.refuseVisible = false;
          let data = {
            action: "audit",
            // templateId:that.ttSensoryTemplateId,
            status: "REJECT",
            remark: that.refuseForm.comments
          };
          console.log(data);
          approvalPass(that.ttSensoryTemplateId, data).then(res => {
            if (res.code == 200) {
              that.$message({
                message: "拒绝成功",
                type: "success"
              });
              that.$router.go(-1);
            }
          });
        } else {
          return false;
        }
      });
    },
    showTemplateName(val) {
      if (val) {
        this.showTemplateNameDialog = true
      }
    },
    formatActive: function (row, column) {
      return row.isActive == "Y" ? "是" : row.isActive == "N" ? "否" : "";
    },
    // 合并单元格
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.title == "Comments") {
        if (columnIndex === 2) {
          return [1, 9];
        }
      }
    },
    // 输入处理函数
    handleInput(index, value, table) {
      console.log("GY🚀 ~ handleInput ~ value:", value);
      this.checkInput(index, value, table)
    },
    // 检测输入是否匹配触发条件
    checkInput(index, value, table) {
      const isMatch = this.triggerKeywords.some(keyword => {
        // 精确匹配且长度相同（防止部分匹配）
        return value === keyword && value.length === keyword.length
      }) ? 'Y' : 'N'
      console.log("GY🚀 ~ checkInput ~ isMatch:", isMatch);
      if (table == 'APPEARANCE') {
        this.$set(this.formTable.AppearanceList[index], 'isComments', isMatch)
        isMatch == 'Y' && this.formTable.AppearanceList[index].title !== 'Comments' ? this.$set(this.formTable.AppearanceList[index], 'visible', true) : this.$set(this.formTable.AppearanceList[index], 'visible', false)
      } else if (table == 'TEXTURE') {
        this.$set(this.formTable.TextureList[index], 'isComments', isMatch)
        isMatch == 'Y' && this.formTable.TextureList[index].title !== 'Comments' ? this.$set(this.formTable.TextureList[index], 'visible', true) : this.$set(this.formTable.TextureList[index], 'visible', false)
        if (this.formTable.TextureList[index].title == 'Comments') {
          this.$set(this.formTable.TextureList[index], 'visible', false)
        }
      } else if (table == 'FLAVOR') {
        this.$set(this.formTable.FlavorList[index], 'isComments', isMatch)
        isMatch == 'Y' && this.formTable.FlavorList[index].title !== 'Comments' ? this.$set(this.formTable.FlavorList[index], 'visible', true) : this.$set(this.formTable.FlavorList[index], 'visible', false)
        if (this.formTable.FlavorList[index].title == 'Comments') {
          this.$set(this.formTable.FlavorList[index], 'visible', false)
        }
      }
    },
    selectSuggestion(val, index, table) {
      console.log("GY🚀 ~ selectSuggestion ~ index:", index);
      console.log("GY🚀 ~ selectSuggestion ~ table:", table);
      console.log("GY🚀 ~ selectSuggestion ~ val:", val);
      if (val) {
        if (table == 'APPEARANCE') {
          this.$set(this.formTable.AppearanceList[index], 'title', val)
          this.$set(this.formTable.AppearanceList[index], 'visible', false)
        } else if (table == 'TEXTURE') {
          this.$set(this.formTable.TextureList[index], 'title', val)
          this.$set(this.formTable.TextureList[index], 'visible', false)
        } else if (table == 'FLAVOR') {
          this.$set(this.formTable.FlavorList[index], 'title', val)
          this.$set(this.formTable.FlavorList[index], 'visible', false)
        }
      }
    },
    // onBlur(index, value, table) {
    //   console.log("GY🚀 ~ onBlur ~ table:", table);
    //   console.log("GY🚀 ~ onBlur ~ index:", index);
    //   console.log("GY🚀 ~ onBlur ~ value:", value.target.value);
    //   this.$nextTick(() => {
    //     if (value.target.value === 'Comments') {
    //       console.log('1231321321')
    //       if (table == 'APPEARANCE') {
    //         console.log('this.eqwwqewq', this.$refs['AppearanceListRef'])
    //         this.$set(this.formTable.AppearanceList[index], 'visible', false)
    //       } else if (table == 'TEXTURE') {
    //         this.$set(this.formTable.TextureList[index], 'visible', false)
    //       } else if (table == 'FLAVOR') {
    //         this.$set(this.formTable.FlavorList[index], 'visible', false)
    //       }
    //     }
    //     this.$forceUpdate()
    //   })
    // },
    querySearch(queryString, cb) {
      var restaurants = [{ value: "Comments" }];
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    addRowAppearance() {
      let len = this.formTable.AppearanceList.length;
      var list = {
        title: "",
        detailType: "APPEARANCE",
        detail1: "",
        detail2: "",
        detail3: "",
        detail4: "",
        detail5: "",
        detail6: "",
        detail7: "",
        detail8: "",
        detail9: "",
        delIds: len,
        isComments: 'Y'
      };
      if (this.formTable.AppearanceList == null) {
        this.formTable.AppearanceList = [];
        this.formTable.AppearanceList.push(list);
      } else {
        this.formTable.AppearanceList.push(list);
      }
    },
    delRowAppearance() {
      let that = this;
      let list = this.formTable.AppearanceList;
      let val = this.$refs.AppearanceListRef.selection;
      if (val.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return;
      } else {
        val.forEach(function (item, index) {
          // 遍历源数据
          list.forEach(function (itemI, indexI) {
            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
            if (item.delIds === itemI.delIds) {
              list.splice(indexI, 1);
            }
          });
        });
      }
      //删除后重新循环list
      list.forEach(function (item, index) {
        item.delIds = index
      });
      this.formTable.AppearanceList = list;
    },
    addRowTexture() {
      let len = this.formTable.TextureList.length;
      var list = {
        title: "",
        detailType: "TEXTURE",
        detail1: "",
        detail2: "",
        detail3: "",
        detail4: "",
        detail5: "",
        detail6: "",
        detail7: "",
        detail8: "",
        detail9: "",
        delIds: len,
        isComments: 'Y'
      };
      if (this.formTable.TextureList == null) {
        this.formTable.TextureList = [];
        this.formTable.TextureList.push(list);
      } else {
        this.formTable.TextureList.push(list);
      }
    },
    delRowTexture() {
      let that = this;
      let list = this.formTable.TextureList;
      let val = this.$refs.TextureListRef.selection;
      if (val.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return;
      } else {
        val.forEach(function (item, index) {
          // 遍历源数据
          list.forEach(function (itemI, indexI) {
            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
            if (item.delIds === itemI.delIds) {
              list.splice(indexI, 1);
            }
          });
        });
      }
      //删除后重新循环list
      list.forEach(function (item, index) {
        item.delIds = index
      });
      this.formTable.TextureList = list;
    },
    addRowFlavor() {
      let len = this.formTable.FlavorList.length;
      var list = {
        title: "",
        detailType: "FLAVOR",
        detail1: "",
        detail2: "",
        detail3: "",
        detail4: "",
        detail5: "",
        detail6: "",
        detail7: "",
        detail8: "",
        detail9: "",
        delIds: len,
        isComments: 'Y'
      };
      if (this.formTable.FlavorList == null) {
        this.formTable.FlavorList = [];
        this.formTable.FlavorList.push(list);
      } else {
        this.formTable.FlavorList.push(list);
      }
    },
    delRowFlavor() {
      let that = this;
      let list = this.formTable.FlavorList;
      let val = this.$refs.FlavorListRef.selection;
      if (val.length == 0) {
        that.$message({ message: that.$t("common.pleaseSelectData"), type: "warning" });
        return;
      } else {
        val.forEach(function (item, index) {
          // 遍历源数据
          list.forEach(function (itemI, indexI) {
            // 如果选中数据跟元数据某一条标识相等，删除对应的源数据
            if (item.delIds === itemI.delIds) {
              list.splice(indexI, 1);
            }
          });
        });
      }
      //删除后重新循环list
      list.forEach(function (item, index) {
        item.delIds = index
      });
      this.formTable.FlavorList = list;
    },
    historyBack() {
      this.$router.push({ name: 'sensoryTemplate' });
    }

  }
};
</script>

<style scoped lang="scss">
.search_btn.is-disabled,
.search_btn.is-disabled:focus,
.search_btn.is-disabled:hover {
  background-color: transparent !important;
  border-color: transparent !important;
}
.toolsBox {
  margin-bottom: 10px;
}

.table_title {
  font-size: 14px;
  color: #606266;

  .table_title_sub {
    height: 30px;
    line-height: 30px;
    border-top: 1px solid #dcdfe6;
  }

  .c1 {
    background: #f0f9eb;
  }
}

.searchBox_top {
  margin-bottom: 20px;
  /*display: flex;*/
}

.el-table {
  margin-top: 10px;
}
</style>
<style lang="scss">
.addTemplate {
  /*.el-form-item__content {*/
  /*  width: 220px;*/
  /*}*/
  .el-select {
    width: 100%;
  }

  .el-date-editor {
    width: 220px;
  }

  .appearanceDesc {
    width: 100%;

    .el-form-item__content {
      width: 100%;
    }
  }

  .el-table {
    margin-bottom: 5px;

    .el-form-item {
      width: 100%;

      .el-form-item__content {
        width: 100%;
      }
    }
  }
}
</style>
